import { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Countdown, { zeroPad } from 'react-countdown';
import { useHistory } from 'react-router-dom';

import Levels from './components/Levels';
import Swiper from './components/Swiper';
import MaterialImage from './components/MaterialImage';
import GameStatusIndicator from './components/GameStatusIndicator';
import Feedback from './components/Feedback';
import LevelClearModal from './components/LevelClearModal';
import Timer from './components/Timer';

import game from './game.json';
import * as actions from '../../redux/actions/swiper';
import SecondsCounter from './components/SecondsCounter';
import MaterialTitle from './components/MaterialTitle';

const Container = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: calc(100vh - 40px - ${Number(window.statusBarHeight || 0)}px);
  margin-top: ${Number(window.statusBarHeight || 0)}px;
`;

let timer;
const FEEDBACK_MESSAGE_DURATION = 1500;
const QUESTION_TIME = 7000;

// Renderer callback with condition
const renderer = ({ seconds }) => <SecondsCounter seconds={zeroPad(seconds)} />;

const SwiperGame = ({
  currentLevel,
  doneMaterials,
  setDoneMaterial,
  setSwiperCurrentLevel
}) => {
  const { replace } = useHistory();
  const [currentMaterial, setCurrentMaterial] = useState(null);
  const [isTimeup, setIsTimeup] = useState(true);
  const [feedback, setFeedback] = useState(null);
  const [finished, setFinished] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [totalCorrectAnswers, setTotalCorrectAnswers] = useState(0);
  const [totalWrongAnswers, setTotalWrongAnswers] = useState(0);
  const timerRef = useRef();

  useEffect(() => {
    setIsTimeup(false);
  }, [currentMaterial]);

  useEffect(() => {
    const setMat = () => {
      // const firstUndoneMaterial = game.rounds[currentLevel].materials
      //   .sort((a, b) => a.oidx > b.oidx)
      //   .find(({ mat_id }) => doneMaterials[currentLevel]
      //     .map((obj) => obj.split('-')[1]).indexOf(mat_id) === -1);
      const firstUndoneMaterial = game.rounds[currentLevel].materials
        .sort((a, b) => a.oidx > b.oidx)
        .find(({ mat_id }) => doneMaterials
          .map((obj) => obj.split('-')[1]).indexOf(mat_id) === -1);

      if (firstUndoneMaterial) return setCurrentMaterial(firstUndoneMaterial);
      return finish();
    };

    if (!finished) setMat();
  }, [currentLevel, doneMaterials]);

  const finish = () => {
    setFinished(true);
    setTotalCorrectAnswers(doneMaterials.filter((mat) => mat.split('-')[0] === 'correct').length);
    setTotalWrongAnswers(doneMaterials.filter((mat) => mat.split('-')[0] === 'wrong').length);
    setModalVisible(true);
  };

  const swipedRecycleable = () => {
    const { can_recycle } = currentMaterial;
    if (can_recycle) return correct();
    return wrong();
  };

  const swipedNOTRecycleable = () => {
    const { can_recycle } = currentMaterial;
    if (!can_recycle) return correct();
    return wrong();
  };

  const correct = () => {
    setFeedback('correct');
    setDoneMaterial(`correct-${currentMaterial.mat_id}`);
  };

  const wrong = () => {
    setFeedback('wrong');
    setDoneMaterial(`wrong-${currentMaterial.mat_id}`);
  };

  useEffect(() => {
    if (!finished && feedback) {
      timer = setTimeout(() => {
        setFeedback(null);
        clearTimeout(timer);
      }, FEEDBACK_MESSAGE_DURATION);
    }
  }, [feedback, finished]);

  if (!currentMaterial) return null;
  const { mat_image } = currentMaterial;

  const onStart = () => {
    if (finished) timerRef.current.stop();
  };

  const onComplete = () => {
    setIsTimeup(true);
    setFeedback('timesup');
    setDoneMaterial(`wrong-${currentMaterial.mat_id}`);
  };

  const onClose = () => {
    replace('/landing');
    setModalVisible(false);
  };

  const onContinue = () => {
    setSwiperCurrentLevel(currentLevel + 1);
    setModalVisible(false);
    setIsTimeup(false);
    setFinished(false);
  };

  return (
    <Container>
      <LevelClearModal
        isVisible={modalVisible}
        clearedLevel={currentLevel + 1} // To handle zero-based index
        totalCorrectAnswers={totalCorrectAnswers}
        totalWrongAnswers={totalWrongAnswers}
        onClose={onClose}
        onContinue={onContinue}
      />
      <Levels
        levels={game.rounds}
        currentLevel={currentLevel}
      />
      {
        feedback
          ? (
            <Feedback
              feedbackStatus={feedback}
            />
          ) : (
            <div>
              <MaterialImage
                src={mat_image}
              />
              <MaterialTitle
                materialName="Cardboard Box"
              />
              <Swiper
                disabled={isTimeup}
                onSwipeLeft={swipedNOTRecycleable}
                onSwipeRight={swipedRecycleable}
              />
              {!finished && (
                <>
                  <Countdown
                    date={Date.now() + QUESTION_TIME}
                    renderer={renderer}
                    ref={timerRef}
                    onStart={onStart}
                    onComplete={onComplete}
                  />
                  <Timer totalTime={QUESTION_TIME} />
                </>
              )}
            </div>
          )
      }
      <div>
        <GameStatusIndicator
          totalMaterials={game.rounds[currentLevel].materials}
          doneMaterials={doneMaterials}
        />
      </div>
    </Container>
  );
};

export default connect(
  (store) => ({
    currentLevel: store.swiper.currentLevel,
    doneMaterials: store.swiper.doneMaterials
  }),
  (dispatch) => ({
    setDoneMaterial: (material) => dispatch(actions.setDoneMaterial(material)),
    setSwiperCurrentLevel: (level) => dispatch(actions.setSwiperCurrentLevel(level))
  })
)(SwiperGame);
